import { inject } from '@angular/core';
import { AuthService } from '@core/services';
import { environment } from '@envs/environment';
import { BCUser, provideNotifications } from '@gozetta/z-messaging';
import { PermissionsList } from '@shared/enum/Permissions/PermissionList';

export const ZNotificationsProvider = provideNotifications({
  platform: 'client',
  baseAPIUrl: environment.mainApiUrl,
  baseCollectionName: [
    ...environment.firebaseCollectionName,
    'notifications',
    'customers',
  ],
  authUserFactory: () => inject(AuthService).currentUser() as unknown as BCUser,
  notificationTabs: [
    {
      id: 'General',
      label: 'General',
      collectionName: ['general'],
      categoryTypes: [
        {
          id: 93,
          name: 'Incident Report',
          routerLink: '/incident-reports',
          permissionId: PermissionsList.CustomerIncidentsReportView,
        },
      ],
    },
    {
      id: 'Videos',
      label: 'Videos',
      collectionName: ['video-requests'],
      categoryTypes: [
        {
          id: 91,
          name: 'Video Request',
          routerLink: '/video-requests',
          permissionId: PermissionsList.CustomerVideoRequestsView,
        },
      ],
    },
    {
      id: 'Routings',
      label: 'Routing',
      collectionName: ['routing-requests'],
      categoryTypes: [
        {
          id: 92,
          name: 'Routing Request',
          routerLink: '/routing-requests',
          permissionId: PermissionsList.CustomerRoutingRequestsView,
        },
      ],
    },
  ],
});
